import { ref } from 'vue';

export function useTimeTableTimeout() {
    const timeout = ref<ReturnType<typeof setInterval> | null>(null);

    const startTimeout = (checks: (() => void)[]) => {
        timeout.value = setInterval(() => {
            checks.forEach((check) => check());
        }, 5000);
    };

    const stopTimeout = () => {
        if (timeout.value === null) {
            return;
        }

        clearTimeout(timeout.value);
    };

    return {
        startTimeout,
        stopTimeout,
    };
}
